<template>
  <ContentWrapperControl no_bottom full_width :centered="false" is_grid
    class="h-screen bg-primary overflow-hidden flex flex-col">
    <div class="flex flex-row mt-2 justify-between items-center w-full text-white text-sm font-medium p-4">
      <button class="rounded-lg p-1 flex items-center justify-center shadow-md navigation">
        <img src="@/assets/icons/papsi_arrow_back_alt.svg" alt="Back" @click="$router.back()" class="w-5 h-5" />
      </button>

      <img :src="getImage('ga/', 'papsi_logo.png')" alt="PAPSI Logo" class="h-6 w-auto object-contain" />

      <button class="rounded-lg p-1 flex items-center justify-center shadow-md navigation"
        @click="show_summary = !show_summary">
        <img src="@/assets/icons/papsi_ballot.svg" alt="Summary" class="w-5 h-5" />
      </button>
    </div>

    <span class="font-bold text-secondary text-xl mt-3 mb-3 text-center block">
      {{ this.lang(category_title_key) }}
    </span>

    <div class="status-chips">
      <div class="chip" :style="{ opacity: getSelectedCount.officers === 0 ? 0.5 : 1 }">
        {{ getSelectedCount.officers }}/3 - {{ this.lang("lbl_0000174") }}
      </div>

      <div class="chip" :style="{ opacity: getSelectedCount.enlisted === 0 ? 0.5 : 1 }">
        {{ getSelectedCount.enlisted }}/3 - {{ this.lang("lbl_0000175") }}
      </div>

      <div class="chip" :style="{ opacity: getSelectedCount.civilians === 0 ? 0.5 : 1 }">
        {{ getSelectedCount.civilians }}/2 - {{ this.lang("lbl_0000350") }}
      </div>
    </div>

    <div class="bg-white rounded-t-3xl w-full p-4 flex-grow overflow-y-auto min-h-0 rounded-t-lg">
      <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 15px">
        <div v-for="candidate in active_candidates" :key="candidate.code" @click="toggleSelect(candidate.code)"
          :class="{ selected: active_selected.includes(candidate.code) }"
          class="candidate-card col-span-1 relative border border-green-600 rounded-xl shadow-sm flex flex-col items-center justify-center bg-white w-full">
          <img v-if="active_selected.includes(candidate.code)" src="@/assets/icons/papsi_check_circle_filled.svg"
            class="check-icon" alt="Selected" />
          <img :src="getImage('ga/', 'papsi_placeholder.jpg')" class="rounded-lg" alt="Candidate Photo" />
          <span
            class="font-bold uppercase text-center text-sm leading-tight mt-2 h-10 flex items-center justify-center">
            {{ candidate.name }}
          </span>
          <span class="text-[10px] text-xs mt-1 text-center">
            {{ candidate.type }}
          </span>
        </div>
      </div>
    </div>

    <div class="bottom-bar">
      <div class="progress-container">
        <div class="progress-fill" :style="{ width: getProgressPercent + '%' }"></div>
      </div>

      <div class="bottom-inner">
        <div class="votes-text">
          <div class="label mb-1">Selected Votes</div>
          <div class="count">{{ getTotalSelected }} of {{ getTotalLimit }}</div>
        </div>
        <div>
          <ButtonControl :outline="true" :full_width="false" class="w-28 mr-3"
            @click="$store.state.ga.selected_candidates[active_category] = []">
            {{ this.lang("lbl_0000017") }}
          </ButtonControl>
          <ButtonControl :full_width="false" class="w-28" :disabled="getTotalSelected < 8" @click="rotateCategory">
            {{ this.lang("lbl_0000015") }}
          </ButtonControl>
        </div>
      </div>
    </div>

    <div v-show="show_summary" class="summary-sidebar">
      <button class="summary-collapse-btn" @click="show_summary = false">
        <img src="@/assets/icons/papsi_summary_collapse.svg" alt="Collapse" class="w-5 h-5" />
      </button>

      <div class="summary-header">My Current Votes</div>

      <div v-if="getSelectedBOD.officers.length" class="summary-group">
        <div class="summary-group-header">
          <div class="summary-group-title">Board of Directors</div>
          <div class="summary-subtitle">Officer Category</div>
        </div>
        <div class="summary-group-body">
          <div v-for="c in getSelectedBOD.officers" :key="c.code" class="summary-item">
            {{ c.name }}
          </div>
        </div>
      </div>

      <div v-if="getSelectedBOD.enlisted.length" class="summary-group">
        <div class="summary-group-header">
          <div class="summary-group-title">Board of Directors</div>
          <div class="summary-subtitle">Enlisted Category</div>
        </div>
        <div class="summary-group-body">
          <div v-for="c in getSelectedBOD.enlisted" :key="c.code" class="summary-item">
            {{ c.name }}
          </div>
        </div>
      </div>

      <!-- Civilians -->
      <div v-if="getSelectedBOD.civilians.length" class="summary-group">
        <div class="summary-group-header">
          <div class="summary-group-title">Board of Directors</div>
          <div class="summary-subtitle">Civilian Category</div>
        </div>
        <div class="summary-group-body">
          <div v-for="c in getSelectedBOD.civilians" :key="c.code" class="summary-item">
            {{ c.name }}
          </div>
        </div>
      </div>
    </div>
  </ContentWrapperControl>
</template>

<script>
import mixin from "@/mixin";
import ContentWrapperControl from "@/components/controls/ContentWrapperControl.vue";
import GA from "@/services/GA";
import ButtonControl from "@/components/controls/ButtonControl.vue";

export default {
  mixins: [mixin],
  emits: ["checkauth", "hidenavbar", "nofooter", "showloader", "hideloader"],
  components: {
    ContentWrapperControl,
    ButtonControl,
  },
  data() {
    return {
      state: null,
      placeholder: "JUAN DELA CRUZ",
      show_summary: false,
      election: {
        code: null,
        title: null,
        date: null,
        candidates: {
          bod: this.$store.state.ga.candidates.bod,
          voting_bod: true,
          elecom: this.$store.state.ga.candidates.elecom,
          voting_elecom: false,
          audit: this.$store.state.ga.candidates.audit,
          voting_audit: false,
        },
      },
    };
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("hidenavbar");
    this.$emit("nofooter", true);
    if (
      this.$store.state.ga.code === null ||
      this.$store.state.ga.candidates.bod.length === 0
    ) {
      this.loadElection();
    }
  },
  computed: {
    category_title_key() {
      const map = {
        bod: "lbl_0000169",
        elecom: "lbl_0000173",
        audit: "lbl_0000176",
      };

      return map[this.active_category];
    },

    selected_bod() {
      const codes = this.$store.state.ga.selected_candidates.bod;
      return this.$store.state.ga.candidates.bod.filter((c) =>
        codes.includes(c.code),
      );
    },

    selected_elecom() {
      const codes = this.$store.state.ga.selected_candidates.elecom;
      return this.$store.state.ga.candidates.elecom.filter((c) =>
        codes.includes(c.code),
      );
    },

    selected_audit() {
      const codes = this.$store.state.ga.selected_candidates.audit;
      return this.$store.state.ga.candidates.audit.filter((c) =>
        codes.includes(c.code),
      );
    },
    active_category() {
      return this.$store.state.ga.active_category;
    },

    active_candidates() {
      return this.$store.state.ga.candidates[this.active_category];
    },

    active_selected() {
      return this.$store.state.ga.selected_candidates[this.active_category];
    },
    getSelectedBOD() {
      const grouped = {
        officers: [],
        enlisted: [],
        civilians: [],
      };

      const bod_candidates = this.$store.state.ga.candidates.bod;
      const bod_selected = this.$store.state.ga.selected_candidates.bod;

      bod_candidates.forEach((candidate) => {
        if (bod_selected.includes(candidate.code)) {
          const type = candidate.type?.toLowerCase();

          if (type.includes("officer")) grouped.officers.push(candidate);
          else if (type.includes("enlisted")) grouped.enlisted.push(candidate);
          else if (type.includes("civilian")) grouped.civilians.push(candidate);
        }
      });

      return grouped;
    },
    getSelectedCount() {
      const bod_candidates = this.$store.state.ga.candidates.bod;
      const bod_selected = this.$store.state.ga.selected_candidates.bod;

      const counts = {
        officers: 0,
        enlisted: 0,
        civilians: 0,
      };

      bod_candidates.forEach((candidate) => {
        if (bod_selected.includes(candidate.code)) {
          const type = candidate.type?.toLowerCase();

          if (type.includes("officer")) counts.officers++;
          else if (type.includes("enlisted")) counts.enlisted++;
          else if (type.includes("civilian")) counts.civilians++;
        }
      });

      return counts;
    },

    getSelectedLimits() {
      return {
        officers: 3,
        enlisted: 3,
        civilians: 2,
      };
    },

    getTotalLimit() {
      return (
        this.getSelectedLimits.officers +
        this.getSelectedLimits.enlisted +
        this.getSelectedLimits.civilians
      );
    },

    getTotalSelected() {
      const c = this.getSelectedCount;
      return c.officers + c.enlisted + c.civilians;
    },

    getProgressPercent() {
      if (!this.getTotalLimit) return 0;
      return (this.getTotalSelected / this.getTotalLimit) * 100;
    },
  },
  methods: {
    toggleSelect(code) {
      const category = this.active_category;

      if (category === "bod") {
        const bod_selected = this.$store.state.ga.selected_candidates.bod;
        const bod_candidates = this.$store.state.ga.candidates.bod;

        const candidate = bod_candidates.find((c) => c.code === code);
        if (!candidate) return;

        const type = candidate.type?.toLowerCase();

        const counts = {
          officers: 0,
          enlisted: 0,
          civilians: 0,
        };

        bod_candidates.forEach((c) => {
          if (bod_selected.includes(c.code)) {
            const t = c.type?.toLowerCase();

            if (t.includes("officer")) counts.officers++;
            else if (t.includes("enlisted")) counts.enlisted++;
            else if (t.includes("civilian")) counts.civilians++;
          }
        });

        const index = bod_selected.indexOf(code);

        if (index !== -1) {
          bod_selected.splice(index, 1);
          return;
        }

        if (type.includes("officer") && counts.officers >= 3) return;
        if (type.includes("enlisted") && counts.enlisted >= 3) return;
        if (type.includes("civilian") && counts.civilians >= 2) return;

        bod_selected.push(code);
        return;
      }

      const selected = this.$store.state.ga.selected_candidates[category];

      const limits = {
        elecom: 2,
        audit: 2,
      };

      const index = selected.indexOf(code);

      if (index !== -1) {
        selected.splice(index, 1);
        return;
      }

      if (selected.length >= limits[category]) return;

      selected.push(code);
    },

    isSelected(group, code) {
      return this.election.selected[group]?.has(code);
    },
    getImage(path, file_name) {
      // const path = "ga/";
      // const file_name = "papsi_placeholder.jpg";
      if (process.env.VUE_APP_CDN_URL) {
        return process.env.VUE_APP_CDN_URL + path + file_name;
      }
    },
    loadElection() {
      this.$emit("showloader");
      GA.getCurrentElection()
        .then((response) => {
          if (response.status === 200) {
            const { code, title, date } = response.data.data;

            this.$store.state.ga.code = code;
            this.election.code = code;
            this.$store.state.ga.title = title;
            this.election.title = title;
            this.$store.state.ga.date = date;
            this.election.date = date;
            this.loadCandidates();
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        });
    },
    loadCandidates() {
      this.$emit("showloader");
      GA.getAllCandidates(this.election.code, this.$store.state.info.hash)
        .then((response) => {
          if (response.status === 200) {
            this.election.candidates.bod = response.data.data.bod;
            this.$store.state.ga.candidates.bod = response.data.data.bod;
            this.election.candidates.elecom = response.data.data.elecom;
            this.$store.state.ga.candidates.elecom = response.data.data.elecom;
            this.election.candidates.audit = response.data.data.audit;
            this.$store.state.ga.candidates.audit = response.data.data.audit;
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => this.$emit("hideloader"));
    },
    rotateCategory() {
      const order = ["bod", "elecom", "audit"];
      const current = this.$store.state.ga.active_category;
      const next = order[(order.indexOf(current) + 1) % order.length];

      this.$store.state.ga.active_category = next;
    },
  },
};
</script>

<style scoped>
.candidate-card {
  border: 2px solid transparent;
  border-radius: 12px;
  padding: 12px;
  cursor: pointer;
  transition: 0.2s;
  border-color: #d7dbdd;
}

.candidate-card.selected {
  border-color: #016b00;
  background: #eaffe9;
}

.status-chips {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.chip {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 9999px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.08);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.navigation {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
}

.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #f3f4f6;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.bottom-inner {
  padding: 10px 16px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
}

.votes-text {
  font-size: 11px;
  line-height: 1.1;
}

.votes-text .label {
  color: #6b7280;
}

.votes-text .count {
  color: #016b00;
  font-weight: 700;
  font-size: 15px;
}

.progress-container {
  width: 100%;
  height: 6px;
  background: rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: #016b00;
  transition: width 0.25s ease;
}

.check-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 26px;
  height: 26px;
  border-radius: 999px;
}

.summary-sidebar {
  position: fixed;
  top: 0;
  right: 0;
  width: 320px;
  height: 100%;
  background: #f1f5f8;
  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.12);
  z-index: 50;
  padding: 16px;
  overflow-y: auto;
  overflow: visible;
}

.summary-group-header {
  background-color: #016b00;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: 12px 12px;
}

.summary-group-body {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 12px 12px;
  background-color: white;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.summary-header {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 16px;
  text-align: center;
  color: #016b00;
}

.summary-group-title {
  font-weight: 700;
  color: white;
}

.summary-subtitle {
  font-size: 12px;
  color: white;
  margin-top: 4px;
}

.summary-item {
  background: #f1f5f8;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px;
  font-size: 13px;
  gap: 8px;
  /* margin-bottom: 8px; */
}

.summary-collapse-btn {
  position: absolute;
  left: -16px;
  top: 50%;
  transform: translateY(-50%);
  background-color: #f1f5f8;
  border-radius: 50%;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 60;
}

.summary-collapse-btn img {
  display: block;
}
</style>
